import PropTypes from 'prop-types';
import React from 'react';
import SalePromotionBlock from '../../cmsBlocks/SalePromotionBlock';
import colors from 'config/theme/colors';
import moduleMargins from 'config/theme/moduleMargins';
import { moduleSettingsProp } from 'utils/proptypes/modules/settingsProps';
import styled from 'libs/styled';

const Wrapper = styled('section')``;

const SalePromotionModule = ({ last = false, settings = {}, ...rest }) => {
    const { background_color: backgroundColor, text_color: textColor } = settings;

    return (
        <Wrapper
            backgroundColor={backgroundColor}
            borderBottom={!last ? `1px solid ${colors.black}` : null}
            padding={moduleMargins.md}
        >
            <SalePromotionBlock moduleTextColor={textColor} {...rest} />
        </Wrapper>
    );
};

SalePromotionModule.propTypes = {
    last: PropTypes.bool,
    settings: moduleSettingsProp,
};

export default SalePromotionModule;
